import { GcxLogo } from "components/UI/molecules/gcx-logo";
import "./index.scss";

export const MobileOrderPageLogo = () => {
  return (
    <div className="mobile-order-page-logo">
      <GcxLogo version="icon" />
    </div>
  );
};
